var _a;
import { createSlice } from '@reduxjs/toolkit';
import { name } from './constants';
var initialState = {};
var getDefaultState = function () {
    return {
        data: {},
        meta: {},
        loading: 'pending',
        error: null,
    };
};
var fillEmptyState = function (state, id) {
    if (!state[id]) {
        state[id] = getDefaultState();
    }
};
export var tournamentsInfo = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        getTournamentByIdPending: function (state, action) {
            var id = action.payload;
            fillEmptyState(state, id);
            state[id].loading = 'pending';
            state[id].error = null;
        },
        getTournamentByIdSuccess: function (state, action) {
            var _a = action.payload, id = _a.id, data = _a.data;
            fillEmptyState(state, id);
            state[id].data = data;
            state[id].meta.defaultRound = data.cstg;
            state[id].meta.lastSelectedRound = data.cstg;
            state[id].loading = 'fulfilled';
            state[id].error = null;
        },
        getTournamentByIdError: function (state, action) {
            var _a = action.payload, id = _a.id, error = _a.error;
            fillEmptyState(state, id);
            state[id].loading = 'rejected';
            state[id].error = error;
        },
        setLastSelectedRound: function (state, _a) {
            var payload = _a.payload;
            var id = payload.id, round = payload.round;
            state[id].meta.lastSelectedRound = round;
        },
    },
});
export var getTournamentByIdPending = (_a = tournamentsInfo.actions, _a.getTournamentByIdPending), getTournamentByIdSuccess = _a.getTournamentByIdSuccess, getTournamentByIdError = _a.getTournamentByIdError, setLastSelectedRound = _a.setLastSelectedRound;
